function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  rx: 1.5,
  height: 3,
  width: 18,
  y: 0.58,
  x: 0.628
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  rx: 1.5,
  height: 3,
  width: 15,
  y: 12.681,
  x: 0.628
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  rx: 1.5,
  height: 3,
  width: 21,
  y: 6.697,
  x: 0.628
});

function SvgMyWorkList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgMyWorkList;